var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "exclamation"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.00561523,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "exclamation_2",
    d: "M12 14.0056C11.7167 14.0056 11.4792 13.9098 11.2875 13.7181C11.0958 13.5264 11 13.2889 11 13.0056V6.00562C11 5.72228 11.0958 5.48478 11.2875 5.29312C11.4792 5.10145 11.7167 5.00562 12 5.00562C12.2833 5.00562 12.5208 5.10145 12.7125 5.29312C12.9042 5.48478 13 5.72228 13 6.00562V13.0056C13 13.2889 12.9042 13.5264 12.7125 13.7181C12.5208 13.9098 12.2833 14.0056 12 14.0056ZM12 19.0056C11.7167 19.0056 11.4792 18.9098 11.2875 18.7181C11.0958 18.5264 11 18.2889 11 18.0056C11 17.7223 11.0958 17.4848 11.2875 17.2931C11.4792 17.1014 11.7167 17.0056 12 17.0056C12.2833 17.0056 12.5208 17.1014 12.7125 17.2931C12.9042 17.4848 13 17.7223 13 18.0056C13 18.2889 12.9042 18.5264 12.7125 18.7181C12.5208 18.9098 12.2833 19.0056 12 19.0056Z",
    fill: "#F45C5C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.0d2310813dcc84ed5bc529916ba77b36.svg";
export { ForwardRef as ReactComponent };